import { render, staticRenderFns } from "./EvaluationReportComments.vue?vue&type=template&id=32d492c0&scoped=true&"
import script from "./EvaluationReportComments.vue?vue&type=script&lang=js&"
export * from "./EvaluationReportComments.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationReportComments.vue?vue&type=style&index=0&id=32d492c0&prod&lang=scss&scoped=true&"
import style1 from "./EvaluationReportComments.vue?vue&type=style&index=1&id=32d492c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d492c0",
  null
  
)

export default component.exports